export default () => ({
  active: 0,
  onPlay: null,
  indicatorStyle: {},
  indicatorReady: false,
  tabObserver: null,
  updateIndicator() {
    const tab = this.$root.querySelectorAll('[role="tab"]')[this.active];
    if (!tab) return;
    this.indicatorStyle = {
      width: `${tab.offsetWidth}px`,
      height: `${tab.offsetHeight}px`,
      transform: `translate(${tab.offsetLeft}px, ${tab.offsetTop}px)`,
    };
    this.indicatorReady = true;
  },
  init() {
    this.onPlay = event => {
      const panel = event.target.closest('[data-feature-panel]');
      if (panel && Number(panel.dataset.featurePanel) !== this.active) event.target.pause();
    };
    this.$root.addEventListener('play', this.onPlay, true);
    this.$nextTick(() => {
      this.updateIndicator();
      this.tabObserver = new ResizeObserver(() => this.updateIndicator());
      this.$root.querySelectorAll('[role="tablist"], [role="tab"]').forEach(element => this.tabObserver.observe(element));
    });
  },
  destroy() {
    this.tabObserver?.disconnect();
    this.$root.removeEventListener('play', this.onPlay, true);
  },
  select(index, focus = false) {
    const tabs = [...this.$root.querySelectorAll('[role="tab"]')];
    if (!tabs.length) return;
    this.active = (index + tabs.length) % tabs.length;
    this.$root.querySelectorAll('[role="tabpanel"]').forEach((panel, i) => {
      if (i !== this.active) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    this.$nextTick(() => {
      this.updateIndicator();
      const tab = tabs[this.active];
      if (focus) tab.focus({ preventScroll: true });
      const bar = tab.parentElement;
      const left = tab.offsetLeft;
      if (left < bar.scrollLeft) bar.scrollLeft = left;
      else if (left + tab.offsetWidth > bar.scrollLeft + bar.clientWidth) {
        bar.scrollLeft = left + tab.offsetWidth - bar.clientWidth;
      }
    });
  },
  keydown(event) {
    const count = this.$root.querySelectorAll('[role="tab"]').length;
    const destinations = { ArrowRight: this.active + 1, ArrowLeft: this.active - 1, Home: 0, End: count - 1 };
    if (!(event.key in destinations)) return;
    event.preventDefault();
    this.select(destinations[event.key], true);
  },
});
